/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, TableCell, Typography } from '@mui/material';
import { TableWidgetV2 } from '../../../components/v2';
import ItemFormulario from './ItemFormulario';
import { formatItemDescricao } from './helpers';

const ItensContainer = ({ itens, onChange, disabled, showError }) => {
  const [currentItens, setCurrentItens] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    setCurrentItens(itens || []);
  }, [itens]);

  const commit = next => {
    setCurrentItens(next);
    onChange(next);
  };

  const renderRows = item => (
    <>
      <TableCell>{item.tipo || item.tipoNome || '-'}</TableCell>
      <TableCell>{formatItemDescricao(item)}</TableCell>
      <TableCell>{item.inspetorAuxiliarName || item.inspetorAuxiliarNome || '-'}</TableCell>
      <TableCell>
        <Typography variant="body2" noWrap title={item.descricao || ''}>
          {item.descricao || '-'}
        </Typography>
      </TableCell>
    </>
  );

  const onDeleteLocal = rowId => {
    commit(currentItens.filter(i => i.id !== rowId));
  };

  const onEdit = rowId => {
    setSelectedItem(currentItens.find(i => i.id === rowId) || null);
    setOpen(true);
  };

  const onUpsertItem = data => {
    const exists = currentItens.some(i => i.id === data.id);
    const next = exists
      ? currentItens.map(i => (i.id === data.id ? data : i))
      : [...currentItens, data];
    setOpen(false);
    setSelectedItem(null);
    commit(next);
  };

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <TableWidgetV2
          rows={currentItens}
          titles={['Tipo', 'Resumo do tipo', 'Ajudante/Observador', 'Descrição']}
          headerTitle="Itens do dia"
          deleteMessage="O item será removido da programação do dia."
          renderRows={renderRows}
          hasRowActions={!disabled}
          onDelete={onDeleteLocal}
          onEdit={onEdit}
          hasAdd={!disabled}
          showDelete={!disabled}
          showEdit={!disabled}
          onAdd={() => {
            setSelectedItem(null);
            setOpen(true);
          }}
          showError={showError}
          showEmptyState={false}
          collapse={false}
          initialExpanded
        />
      </Grid>
      <ItemFormulario
        open={open}
        selectedItem={selectedItem}
        onClose={() => {
          setOpen(false);
          setSelectedItem(null);
        }}
        onSave={onUpsertItem}
      />
    </>
  );
};

ItensContainer.propTypes = {
  itens: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  showError: PropTypes.bool,
};

ItensContainer.defaultProps = {
  itens: [],
  disabled: false,
  showError: false,
};

export default ItensContainer;
